<div fxLayout="column" fxLayoutGap="15px" style="padding-bottom: 40px">
  <mat-form-field class="filterField" *ngIf="!adminHasChosenCompany()">
    <input
      matInput
      (keyup)="applyFilter($event.target.value)"
      autocomplete="off"
      [(ngModel)]="filterValue"
      placeholder="{{ 'AppComponent.Search' | translate }}"
      [formControl]="filterControl"
    />
  </mat-form-field>
  <div *ngFor="let company of companiesService.companies$ | async | filterCompanies : filterValue" class="companyRow">
    <div
      fxLayout="row"
      fxLayoutGap="20px"
      class="filters"
      style="cursor: pointer"
      (click)="onExpand(company, !company.expand)"
      onKeyPress
      onKeyDown
      onKeyUp
    >
      <!-- Company Left side -->
      <div class="center">
        <img
          class="img"
          [src]="companiesLogoErrorState[company._id] ? 'assets/img/citymesh-logo-user.png' : company.logo"
          alt
          (error)="handleImageError(company._id)"
        />
        <div class="row-title">{{ company.name || '-' }}</div>
      </div>
      <!-- company Right side -->
      <div class="center">
        <button
          *ngIf="companiesService.checkEnableFunction(companiesService.rolesEnableForEdit, authService.user.role)"
          class="center-button edit-button"
          mat-raised-button
          (click)="editCompany(company)"
        >
          <mat-icon svgIcon="edit_square" class="icon edit-icon"></mat-icon>
          {{ 'Settings.EditLabel' | translate }}
        </button>
        <mat-icon>{{ company.expand ? 'keyboard_arrow_down' : 'chevron_right' }}</mat-icon>
      </div>
    </div>
    <div *ngIf="company.expand" class="expanded-box">
      <div>{{ 'Settings.Info' | translate }}</div>
      <div class="expanded-info-parent">
        <div class="expanded-info-column">
          <div class="expanded-info-title">
            {{ ('Settings.Company' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.name || '-' }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.Contact' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.contact || '-' }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.WebLink' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.webUrl || '-' }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.CompanyLogo' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            <img *ngIf="company.logo" class="company-logo" [src]="company.logo" alt />
            <img *ngIf="!company.logo" class="company-logo" src="assets/img/citymesh-logo-user.png" alt />
          </div>
        </div>

        <div class="expanded-info-column">
          <div class="expanded-info-title">
            {{ ('Settings.Country' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{
              company?.country?.iso != undefined && company?.country?.iso != ''
                ? ('AppComponent.Countries.' + company?.country?.iso | translate)
                : '-'
            }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.Language' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.language && ('Settings.Languages.' + company.language | translate) }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.LinkName' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.linkName || '-' }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.PrimaryColor' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            <div class="color-box" [style.background-color]="company.colorPalette.primary"></div>
          </div>
        </div>

        <div class="expanded-info-column">
          <div class="expanded-info-title">
            {{ ('Settings.EmailAdmin' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.email || '-' }}
          </div>

          <div class="expanded-info-title">
            {{ ('Settings.Location' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.location.lat && company.location.lng ? company.location.lat + ', ' + company.location.lng : '' }}
          </div>

          <div *ngIf="roleAllowed()">
            <div class="expanded-info-title">
              {{ ('Settings.IP' | translate).toUpperCase() }}
            </div>
            <div class="expanded-info-value">
              <div *ngIf="company.ip">
                {{ convertIp(company.ip) }}
              </div>
              <div *ngIf="!company.ip">-</div>
            </div>
          </div>
        </div>

        <div *ngIf="roleAllowed()" class="expanded-info-column">
          <div class="expanded-info-title">
            {{ ('Settings.EzvizAccount' | translate).toUpperCase() }}
          </div>
          <div class="expanded-info-value">
            {{ company.ezvizAccountName || '-' }}
          </div>
        </div>
      </div>

      <div class="content-section">
        <app-receivers-list-component [company]="company"></app-receivers-list-component>
        <app-users-list-component [company]="company"></app-users-list-component>
        <app-configuration-list-component [company]="company"></app-configuration-list-component>
      </div>
    </div>
  </div>
</div>
